import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { Typography } from 'Components/Typography';

const Root = styled.div`
  position: relative;
`;

const Image = styled.img`
  display: block;
  width: 100%;
`;

const Legend = styled(Typography)`
  position: absolute;
  top: 10px;
  left: 10px;

  max-width: calc(100% - 20px);
  padding: 5px 22px;

  background-color: ${theme.colors.neutral[100]};
`;

export type ConsultationTipImage = {
  alt?: string;
  legend?: string;
  src: { src: string };
};

export const ImageWithLegend = ({ alt, legend, src }: ConsultationTipImage) => (
  <Root>
    <Image alt={alt} src={src.src} />

    {legend && (
      <Legend align="center" italic variant="p3">
        {legend}
      </Legend>
    )}
  </Root>
);
